import { Component, OnInit } from '@angular/core';
import { StoreService } from "../../../../shared/services/store.service";
import { Router } from "@angular/router";
import { AuthService } from 'projects/frontend/src/app/shared/services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { InstitutionCategoriesService } from 'projects/frontend/src/app/shared/services/personal-area/institution-categories/institution-categories.service';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
    standalone: false
})
export class ServicesComponent implements OnInit {
  get authorityId() {
    return this.storeService.authority?.codiceIpaEnte
  }

  //authorityId: string | undefined

  constructor(
    public storeService: StoreService,
    public institutionCategoriesService: InstitutionCategoriesService,
    public authService: AuthService,
    public router: Router,
    public translateService: TranslateService
  ) { }

  ngOnInit(): void {
    //this.authorityId = this.storeService.authority?.codiceIpaEnte
    this.institutionCategoriesService.getServiziSpontanei(this.storeService.codIpa);
  }
}
